import { useState } from 'react'
import PageHeader from '@/components/settings/PageHeader'
import { TabNavigation } from '@/components/shared/molecules/TabNavigation'
import { createFileRoute } from '@tanstack/react-router'
import TabArchiveProducts from '@/components/settings/TabArchiveProduct'
import { useCurrentUser } from '@/hooks/useCurrentUser'
import {
    useUserProducts,
    // useUserLooks,
    useUserCollections,
} from '@/hooks/api/useUsers'
// import TabArchiveLook from '@/components/settings/TabArchiveLook'
import { TabArchiveCollection } from '@/components/settings/TabArchiveCollection'
import { TabArchiveTryOn } from '@/components/settings/TabArchiveTryOn'
import { classNames } from '@/utils/classNames'
import { useQueryClient } from '@tanstack/react-query'
import type { NormalizedCollection } from '@wtf/shared'

const tabs = [
    {
        label: 'Products',
        value: 'products',
    },
    // {
    //     label: 'Looks',
    //     value: 'looks',
    // },
    {
        label: 'Collections',
        value: 'collections',
    },
    {
        label: 'Try-Ons',
        value: 'try-ons',
    },
]

export const Route = createFileRoute('/settings/archive')({
    component: RouteComponent,
})

function RouteComponent() {
    return <ArchivePage />
}

export const ArchivePage = ({
    asChildren = false,
    rootClassNames,
}: {
    asChildren?: boolean
    rootClassNames?: string
}) => {
    const [activeTab, setActiveTab] = useState(tabs[0].value)
    const { user, loading: userLoading } = useCurrentUser()
    const userId = user?.uid
    const queryClient = useQueryClient()

    const { data: productsResponse, isLoading: productsLoading } =
        useUserProducts(userId)
    const productIds = productsResponse?.products.map((p) => p.id) ?? []

    // const { data: looksResponse, isLoading: looksLoading } =
    //     useUserLooks(userId)
    // const lookIds = looksResponse?.looks.map((l) => l.id) ?? []

    const { data: collectionIds = [], isLoading: collectionsLoading } =
        useUserCollections(userId)

    // Filter to show ONLY archived collections
    const archivedCollectionIds = collectionIds.filter((cid) => {
        const col = queryClient.getQueryData<NormalizedCollection>([
            'collection',
            cid,
        ])
        return col && col.isArchived
    })

    // Optional: handle loading state
    if (userLoading || productsLoading || collectionsLoading) {
        return <div>Loading...</div>
    }

    return (
        <div
            className={classNames(
                'h-[100dvh] overflow-y-auto bg-white px-2 pb-15 lg:px-0',
                rootClassNames
            )}
        >
            {!asChildren && <PageHeader title="Archive" />}
            <TabNavigation
                tabs={tabs}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />

            {activeTab === 'products' && (
                <TabArchiveProducts productIds={productIds} />
            )}
            {/* {activeTab === 'looks' && <TabArchiveLook lookIds={lookIds} />} */}
            {activeTab === 'collections' && (
                <TabArchiveCollection collectionIds={archivedCollectionIds} />
            )}
            {activeTab === 'try-ons' && <TabArchiveTryOn />}
        </div>
    )
}
